import { DateTimeRange, DatePicker } from '@components/TimePicker'
import { ButtonSwitch } from '@components/ButtonSwitch'
import { DATE_FORMAT } from 'shared/constants'
import featureToggles from 'shared/featureToggles'

const SearchBar = ({
    isHourly = true,
    start,
    end,
    startOfWeek,
    onDateTimeChange,
    onHourlyButtonClick,
    onMonthlyButtonClick,
    showSwitchButtons,
}) => (
    <div className="row align-items-end">
        {showSwitchButtons && (
            <div className="col-sm-auto col mt-4 mt-sm-0">
                <ButtonSwitch
                    label={<T>label.parking</T>}
                    buttons={[
                        {
                            label: <T>label.parking.hourly</T>,
                            onClick: onHourlyButtonClick,
                            active: isHourly,
                        },
                        {
                            label: <T>label.parking.monthly</T>,
                            onClick: onMonthlyButtonClick,
                            active: !isHourly,
                        },
                    ]}
                />
            </div>
        )}
        {isHourly && (
            <div className="col-xl-6 col-md-8 mt-3 mt-md-0">
                <DateTimeRange
                    startOfWeek={startOfWeek}
                    startOptions={{
                        datePickerOptions: { label: <T>label.parking.start</T> },
                        timePickerOptions: { label: <T>label.datetime.info</T> },
                    }}
                    endOptions={{
                        datePickerOptions: { label: <T>label.parking.end</T> },
                        timePickerOptions: { label: <T>label.datetime.info</T> },
                    }}
                    start={start}
                    end={end}
                    onChange={onDateTimeChange}
                />
            </div>
        )}
        {!isHourly && !featureToggles.hasEventFlow && (
            <>
                <div className="col-sm-6 col-md-3 col-lg-2 mt-3 mt-md-0">
                    <DatePicker
                        label={<T>label.parking.start</T>}
                        value={start}
                        onChange={onDateTimeChange}
                        displayFormat={DATE_FORMAT}
                    />
                </div>
            </>
        )}
    </div>
)

export default SearchBar
